var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import Component from "vue-class-component";
var SideAnchorMenu = /** @class */ (function (_super) {
    __extends(SideAnchorMenu, _super);
    function SideAnchorMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.position = 'right'; // 位置：left / right
        // 展开/收起
        _this.isExpand = false;
        return _this;
    }
    Object.defineProperty(SideAnchorMenu.prototype, "triggerStyle", {
        get: function () {
            var _a;
            return _a = {
                    position: 'fixed',
                    top: this.top + 'px',
                    bottom: this.bottom + 'px',
                    zIndex: 999
                },
                _a[this.position] = '0',
                _a.width = this.triggerWidth + 'px',
                _a.height = this.triggerHeight + 'px',
                _a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideAnchorMenu.prototype, "wrapperStyle", {
        //计算外层容器样式
        get: function () {
            var _a;
            return _a = {
                    position: 'fixed',
                    top: this.top + 'px'
                },
                _a[this.position] = this.offset + 'px',
                _a.zIndex = 999,
                _a;
        },
        enumerable: false,
        configurable: true
    });
    // 截取第一个字
    SideAnchorMenu.prototype.getFirstChar = function (str) {
        if (!str)
            return '';
        return str.charAt(0);
    };
    __decorate([
        Prop({ default: "right", validator: function (val) { return ['left', 'right'].includes(val); } })
    ], SideAnchorMenu.prototype, "position", void 0);
    __decorate([
        Prop({ type: [Number, String], default: null })
    ], SideAnchorMenu.prototype, "top", void 0);
    __decorate([
        Prop({ type: [Number, String], default: 100 })
    ], SideAnchorMenu.prototype, "bottom", void 0);
    __decorate([
        Prop({ type: [Number, String], default: 20 })
    ], SideAnchorMenu.prototype, "offset", void 0);
    __decorate([
        Prop({ type: [Number], default: 30 })
    ], SideAnchorMenu.prototype, "triggerWidth", void 0);
    __decorate([
        Prop({ type: [Number], default: 200 })
    ], SideAnchorMenu.prototype, "triggerHeight", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], SideAnchorMenu.prototype, "menus", void 0);
    SideAnchorMenu = __decorate([
        Component({
            components: {}
        })
    ], SideAnchorMenu);
    return SideAnchorMenu;
}(Vue));
export default SideAnchorMenu;
